<mat-toolbar _ngcontent-fgg-c233="" class="mat-toolbar mat-toolbar-single-row">{{ "idle.sessionExpire" | translate }}</mat-toolbar>


<form fxLayout="row wrap" fxLayoutAlign="space-between none" class="form-signin p-15">
   
        <div fxFlex="96">
            {{ "idle.expireText" | translate : { count: count } }}
        </div>
        <div fxFlex="96">
            <mat-dialog-actions align="center">
                <button mat-button mat-dialog-close (click)="logOut()">{{ "no" | translate }}</button>
                <button mat-button color="primary" mat-dialog-close (click)="stopIdle()"> {{ "yes" | translate }}</button>
              </mat-dialog-actions>
        </div>
</form>


